export default "__VITE_ASSET__CfBj37cz__"